// `custom-event` (via @webscopeio/react-textarea-autocomplete) reads bare `global` when it loads,
// and Vite's dev dependency pre-bundle leaves it unrewritten. The entry must import this first.
declare global {
  interface Window {
    global: Window
  }
}

window.global = window

export {}
